import React from "react";
import "./Profile.css";
import { Link } from "react-router-dom";
import { useLanguage } from "./LanguageContext";

function Crunches(props) {
  const { t } = useLanguage();
  const titleMaxSize = 15;

  function getShortedTitle(title) {
    return title.length > titleMaxSize ? title : title;
  }

  return (
    <div className="crunches breadcrumbs">
      <div className="crunches-row">
        {props.target !== "" ? (
          <div className="crunches-element crunches-trail">
            <div className="crunches-crop" role="navigation" aria-label={t("breadcrumbLabel")}>
              <Link to="/">{t("home")}</Link>
              <span aria-hidden="true">/</span>
              {props.backOverride ? (
                <>
                  <Link to={props.backOverride.path}>{props.backOverride.label}</Link>
                  <span aria-hidden="true">/</span>
                </>
              ) : (
                <>
                  {props.target.category ? (
                    <>
                      <Link to={`/${props.target.category.toLowerCase()}`}>{props.target.category}</Link>
                      <span aria-hidden="true">/</span>
                    </>
                  ) : null}
                  {props.target.subcategory ? (
                    <>
                      <Link
                        to={
                          (props.target.category ? "/" + props.target.category.toLowerCase() : "") +
                          "/" + props.target.subcategory.toLowerCase()
                        }
                      >
                        {" " + (props.target.subcategoryLabel ?? props.target.subcategory) + " "}
                      </Link>
                      <span aria-hidden="true">/</span>
                    </>
                  ) : null}
                </>
              )}
              <span aria-current="page">{getShortedTitle(props.target.title)}</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Crunches;
